<div class="card-body">
    <div id="apex-spline-area-chart"></div>
</div>